"use strict";function e(e){return e&&e.__esModule?e:{default:e}}var t=e(require("get-user-locale"));function r(e){return(r,o)=>function(e){return(r,o)=>o.toLocaleString(r||t.default(),e)}(e)(r,function(e){const t=new Date(e);return new Date(t.setHours(12))}(o))}const o=r({day:"numeric"}),n=r({day:"numeric",month:"long",year:"numeric"}),a=r({month:"long"}),u=r({month:"long",year:"numeric"}),s=r({weekday:"short"}),m=r({weekday:"long"}),c=r({year:"numeric"});exports.formatDay=o,exports.formatLongDate=n,exports.formatMonth=a,exports.formatMonthYear=u,exports.formatShortWeekday=s,exports.formatWeekday=m,exports.formatYear=c;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/components/ReactCalendar/shared/dateFormatter.js
// module id = 163
// module chunks = 0